import React from 'react';
import { Button, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FiInfo } from 'react-icons/fi';
import { IconMeasure, MessagesIcon, PlannerIcon } from '../../../../../shared/Icons';
import { IMyOffers } from '../../dto/IDashboard';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { useNavigate } from 'react-router-dom';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import { UserRoles } from '../../../../../enum/UserRoles';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';

interface Props {
    myOffers: IMyOffers;
}

const PlannerReports = ({ myOffers }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        user: { userType },
    } = useSelector((reduxState: IAllStates) => reduxState.auth);

    const navigateToAction = (path: string) => {
        [UserRoles.AGENCY, UserRoles.AGENCY_MASTER].includes(userType as UserRoles)
            ? navigate(`/agency/${path}`)
            : navigate(`/influencer/${path}`);
    };

    return (
        <CardLayout>
            <Row className="align-items-start h-100">
                <div className="border-right col-4 d-flex flex-column justify-content-between h-100">
                    <h6 className="d-flex align-items-center text-muted">
                        <PlannerIcon width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                        <div>{t('influencer.dashboard.contentPlanner')}</div>
                    </h6>
                    <div className="d-flex align-items-center justify-content-between mt-1">
                        <div className="col-6 px-0">
                            <h5 className="text-primary mb-0">{myOffers?.plannerTodo ?? 0}</h5>
                            <div className="d-flex align-items-center">
                                To Do
                                <TooltipOverlay
                                    className="ms-1"
                                    content={t(`influencer.dashboard.contentPlannerToDoTooltip`)}
                                >
                                    <FiInfo size={14} />
                                </TooltipOverlay>
                            </div>
                        </div>
                        <Button variant="outline-primary" onClick={() => navigateToAction('planner')}>
                            {t('general.button.planner')}
                        </Button>
                    </div>
                </div>
                <div className="border-right col-4 d-flex flex-column justify-content-between h-100">
                    <h6 className="text-muted d-flex align-items-center">
                        <IconMeasure width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                        <div>{t('influencer.dashboard.reporting')}</div>
                    </h6>
                    <div className="d-flex align-items-center justify-content-between mt-1">
                        <div className="col-4 px-0">
                            <h5 className="text-primary mb-0">{myOffers?.reportsTodo ?? 0}</h5>
                            <div className="d-flex align-items-center">
                                To Do
                                <TooltipOverlay
                                    className="ms-1"
                                    content={t(`influencer.dashboard.reportingToDoTooltip`)}
                                >
                                    <FiInfo size={14} />
                                </TooltipOverlay>
                            </div>
                        </div>
                        <Button variant="outline-primary" onClick={() => navigateToAction('reporting')}>
                            {t('general.button.reporting')}
                        </Button>
                    </div>
                </div>
                <div className="col-4 d-flex flex-column justify-content-between h-100">
                    <h6 className="text-muted d-flex align-items-center">
                        <MessagesIcon width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                        <div>{t('influencer.campaign.tabs.messages')}</div>
                    </h6>
                    <div className=" d-flex align-items-center justify-content-between mt-1">
                        <div>
                            <h5 className="text-primary mb-0">{myOffers?.messages ?? 0}</h5>
                            <span>{t('influencer.dashboard.newMessages')}</span>
                        </div>
                        <Button variant="outline-primary" onClick={() => navigateToAction('messages')}>
                            {t('general.button.see_messages')}
                        </Button>
                    </div>
                </div>
            </Row>
        </CardLayout>
    );
};

export default PlannerReports;
